import { useQuery } from '@tanstack/react-query'
import { apiV1 } from '@/shared/api/apiPrefix'
import { httpClient } from '@/shared/lib/httpClient'
import {
  beneficiariesListResponseSchema,
  type BeneficiaryDeclarationSettings,
  type BeneficiaryRow,
} from '@/shared/schemas/beneficiariesApi.schema'

export const beneficiariesKeys = {
  all: ['beneficiaries'] as const,
  list: () => [...beneficiariesKeys.all, 'list'] as const,
}

const DEFAULT_DECLARATION_SETTINGS: BeneficiaryDeclarationSettings = {
  declaration_enabled: true,
  justificatif_enabled: false,
  justificatif_required: false,
  can_add_partner: true,
  allowed_relations: [],
}

type BeneficiariesPayload = { rows: BeneficiaryRow[]; settings: BeneficiaryDeclarationSettings }

function beneficiariesQueryOptions() {
  return {
    queryKey: beneficiariesKeys.list(),
    queryFn: async (): Promise<BeneficiariesPayload> => {
      const res = await httpClient.get<unknown>(apiV1('/me/beneficiaries'))
      const parsed = beneficiariesListResponseSchema.parse(res.data)
      return { rows: parsed.data, settings: parsed.meta ?? DEFAULT_DECLARATION_SETTINGS }
    },
  }
}

export function useBeneficiariesList() {
  return useQuery({
    ...beneficiariesQueryOptions(),
    select: (payload): BeneficiaryRow[] => payload.rows,
  })
}

export function useBeneficiaryDeclarationSettings(): BeneficiaryDeclarationSettings {
  const query = useQuery({
    ...beneficiariesQueryOptions(),
    select: (payload): BeneficiaryDeclarationSettings => payload.settings,
  })

  return query.data ?? DEFAULT_DECLARATION_SETTINGS
}
